import { ErrorBoundary, withErrorBoundary } from './ErrorBoundary'

export { ErrorBoundary, withErrorBoundary }
